import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import AdminApp from './components/AdminApp';
import reportWebVitals from './reportWebVitals';



ReactDOM.render(
    <React.StrictMode>
        {new URLSearchParams(document.location.search).has('admin') ? <AdminApp /> : <App />}

    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
